<template>
  <div class="attachable-widget-component flex-col">
    <upload-modal
      v-if="attachableCategories.length"
      @close="refreshActiveCategory"
      :categorySet="true"
    >
    </upload-modal>
    <document-modals></document-modals>
    <dd-loading-indicator v-if="loadingCategories"></dd-loading-indicator>
    <attachable-category-card
      v-if="!loadingCategories"
      v-for="category of attachableCategories"
      :key="category.id"
      :category="category"
      style="margin-bottom: 12px"
    >
      <template #action>
        <dd-button
          small
          class="mr-sm"
          @click="() => createAttachable(category)"
        >
          uploaden
          <template #icon>
            <PlusIcon class="icon-size-md"></PlusIcon>
          </template>
        </dd-button>
      </template>
    </attachable-category-card>
  </div>
</template>

<script>
import { Skeleton } from 'vue-loading-skeleton'
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex'
import { mapFields } from "vuex-map-fields";
import store from "./store";
import UploadModal  from "./UploadModal.vue";
import DocumentActions from './DocumentActions.vue';
import DocumentModals from './DocumentModals.vue';
import AttachableCategoryCard from "./AttachableCategoryCard.vue";
export default {
  name: 'AttachableWidgetComponent',

  props: {
    hasAttachableType: {
      type: String,
      required: true
    },
    hasAttachableId: {
      type: [String, Number],
      required: true
    },
    category: {
      type: Number,
      required: false,
      default: null
    },
    isInstance: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  beforeCreate() {
    const STORE_KEY = '$_attachable_widget'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }
  },
  components: {
    Skeleton,
    UploadModal,
    DocumentModals,
    DocumentActions,
    AttachableCategoryCard
  },
  data () {
    return {
      updateNameLoading: false,
      processLoading: false,
      unmatchLoading: false,
      noteCount: 0,
    }
  },
  mounted() {
    this.onInit();
  },
  computed: {
    ...mapFields(`$_attachable_widget`, [
        'activeAttachableCategoryName',
    ]),
    ...mapState(`$_attachable_widget`, {
      loadingCategories: 'loadingCategories',
      selectedAttachables: 'selectedAttachables',
      showUploadModal: 'showUploadModal',
      attachableCategories: 'attachableCategories',
      attachables: 'attachables',
      tableHeaders: 'tableHeaders',
    }),
    ...mapGetters(['forceIntersect']),
    ...mapGetters('$_attachable_widget', [
      'activeAttachableCategory',
      'hasCategory',
      'hasAttachableInstance',
    ]),
    showLink () {
      return this.childInstance.show_link
    },
  },
  methods: {
    onUpdateSelected(selected) {
      this.setSelectedAttachables(selected);
    },
    refreshActiveCategory(category) {
      // TODO: optimize this, we don't need to retrieve all categories.
      this.getAttachableCategories();
      this.getAttachablesForCategory(category);
    },
    createAttachable(category) {
      if (category.template){
        this.createCategoryFromTemplate(category);
      }
      this.setActiveCategoryName(category.name);
      this.$nextTick(() => this.setShowUploadModal(true));
    },
    deleteAttachable(attachable) {
      this.deleteAttachable(attachable);
    },
    ...mapActions(`$_attachable_widget`, {
      getAttachableCategories: 'getAttachableCategories',
      getAttachablesForCategory: 'getAttachablesForCategory',
      createCategoryFromTemplate: 'createCategoryFromTemplate',
      deleteAttachable: 'deleteAttachable',
    }),
    ...mapMutations(`$_attachable_widget`, {
      setSelectedAttachables: 'SET_SELECTED_ATTACHABLES',
      setActiveCategoryName: 'SET_ACTIVE_ATTACHABLE_CATEGORY_NAME',
      setShowUploadModal: 'SET_SHOW_UPLOAD_MODAL',
      setAttachableCategories: 'SET_ATTACHABLE_CATEGORIES',
      setHasAttachableType: 'SET_HAS_ATTACHABLE_TYPE',
      setHasAttachableId: 'SET_HAS_ATTACHABLE_ID',
      setIsInstance : 'SET_IS_INSTANCE',
      setCategory: 'SET_CATEGORY',
    }),
    onInit() {
      this.setCategory(this.category);
      this.setHasAttachableId(this.hasAttachableId);
      this.setHasAttachableType(this.hasAttachableType);
      this.setIsInstance(this.isInstance);
      //
      this.getAttachableCategories();
    },
    getAttachableCount (key) {
      return this.attachableCategories[key]?.attachable_count?.data?.count || 0
    },
    handleCollapse (value) {
      this.activeAttachableCategory = value
    },
    onAttachableCategoryCountUpdated (attachableCategoryId, count) {
      const index = this.attachableCategories.findIndex(attachableCategory => attachableCategory.id === attachableCategoryId)
      let attachableCategory = this.attachableCategories[index]

      if (attachableCategory.template) {
        this.$nextTick(async () => {
          // TODO: fix collapse panel rerender bug before enabling
          // Vue.set(this.attachableCategories[index].attachable_count, {})
          // Vue.set(this.attachableCategories[index].attachable_count.data, {})
          // Vue.set(this.attachableCategories[index].attachable_count.data.count, count)
        })
      } else {
        Vue.set(this.attachableCategories[index].attachable_count.data.count, count)
      }
    }
  },
}
</script>

<style>

.attachable-widget-component {
}

.attachable-widget-component .notes-panel .ant-collapse-header,
.attachable-widget-component .attachable-category .ant-collapse-header {
  background-color: #98aebf !important;
  color: white !important;
}

</style>
